export default __webpack_public_path__ + "static/media/srcdev_nl.07767aac.png";